import { render, staticRenderFns } from "./AddOrEditB2BAssessmentPackageAssignment.vue?vue&type=template&id=292456e6"
import script from "./AddOrEditB2BAssessmentPackageAssignment.vue?vue&type=script&lang=js"
export * from "./AddOrEditB2BAssessmentPackageAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports